import {
	SET_FREQUENCY_SETTINGS_IDS,
	FETCH_CONFIGURED_LIMITS,
	RESET_CONFIGURED_LIMITS,
	RESET_FREQUENCY_SETTINGS_IDS,
	SHOW_DELETE_LIMIT_DIALOG,
	HIDE_DELETE_LIMIT_DIALOG,
	SHOW_UPDATE_LIMIT_DIALOG,
	HIDE_UPDATE_LIMIT_DIALOG
} from "./ConfiguredLimitsActionsTypes";
import FrequencyTrendLimitConfigurationService from "../../service/FrequencyTrendLimitConfigurationService";
import { RESET_STATE } from "@/stores/CommumActionTypes";

const actions = {
	/**
   * Define os IDs das configurações de frequência e guarda no state.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {Object} frequencySignalsGroupedByName - Objeto contendo informações agrupadas por nome.
   */
	[SET_FREQUENCY_SETTINGS_IDS]: ({ commit }, frequencySignalsGroupedByName) =>
	{
		if (!frequencySignalsGroupedByName)
		{
			commit(SET_FREQUENCY_SETTINGS_IDS, []);
			return;
		}

		const ids = frequencySignalsGroupedByName.info.map((item) => item.frequencyTrendSettingId);

		commit(SET_FREQUENCY_SETTINGS_IDS, ids);
	},

	/**
   * Reseta os IDs das configurações de frequência.
   *
   * @param {Object} context - O contexto Vuex.
   */
	[RESET_FREQUENCY_SETTINGS_IDS]: ({ commit }) =>
	{
		commit(RESET_FREQUENCY_SETTINGS_IDS);
	},

	/**
   * Busca as configurações de limites configurados de tendências de frequência na API e guarda no state.
   *
   * @param {Object} context - O contexto Vuex.
   */
	[FETCH_CONFIGURED_LIMITS]: async({ commit, state }) =>
	{
		let tableData = [];
		let filteredTableData = [];

		if (state.frequencySettingsIds.length !== 0)
		{
			tableData = await FrequencyTrendLimitConfigurationService
				.GetFrequencyTrendLimitsConfigurationModels(state.frequencySettingsIds);
			filteredTableData = tableData.filter(td => td.isLimitEnabled);
		}

		commit(FETCH_CONFIGURED_LIMITS, filteredTableData);
	},

	/**
   * Reseta os limites configurados.
   *
   * @param {Object} context - O contexto Vuex.
   */
	[RESET_CONFIGURED_LIMITS]: ({ commit }) =>
	{
		commit(RESET_CONFIGURED_LIMITS);
	},

	/**
   * Muda o estado do diálogo de deletar limites para true, para aparecer no front.
   *
   * @param {Object} context - O contexto Vuex.
   */
	[SHOW_DELETE_LIMIT_DIALOG]: ({ commit }) =>
	{
		commit(SHOW_DELETE_LIMIT_DIALOG);
	},

	/**
   * Muda o estado do diálogo de deletar limites para false, para esconder o dialogo front.
   *
   * @param {Object} context - O contexto Vuex.
   */
	[HIDE_DELETE_LIMIT_DIALOG]: ({ commit }) =>
	{
		commit(HIDE_DELETE_LIMIT_DIALOG);
	},

	/**
   * Muda o estado do diálogo de atualizar limites  para true, para aparecer no front.
   *
   * @param {Object} context - O contexto Vuex.
   */
	[SHOW_UPDATE_LIMIT_DIALOG]: ({ commit }) =>
	{
		commit(SHOW_UPDATE_LIMIT_DIALOG);
	},

	/**
   * Muda o estado do diálogo de atualizar limites para false, para esconder o dialogo front.
   *
   * @param {Object} context - O contexto Vuex.
   */
	[HIDE_UPDATE_LIMIT_DIALOG]: ({ commit }) =>
	{
		commit(HIDE_UPDATE_LIMIT_DIALOG);
	},

	/**
   * Reseta todos os states desse modulo.
   *
   * @param {Object} context - O contexto Vuex.
   */
	[RESET_STATE]: ({ commit }) =>
	{
		commit(RESET_STATE);
	},
};

export default { actions };